(() => {
	function EmailTemplatesController(
		$scope,
		$rootScope,
		$location,
		messageService,
		validationService,
		stringModifierService,
		fileUploadService,
		emailSettingsDataService,
		templateRequestsService,
		$timeout,
		$http,
		utilsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isDeleteTemplateSpinnningWheelActive = false;
			$scope.isSaveSpinnningWheelActive = false;
			$scope.isEditTemplateSpinnningWheelActive = false;
			$scope.isAddTemplateSpinnningWheelActive = false;
			$scope.isConfirmUpdateTemplateModalActive = false;

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			initReminder();
		});

		clearEditedAttachments();
		clearNewAttachments();

		function clearEditedAttachments() {
			$scope.editedAttachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearNewAttachments() {
			$scope.newAttachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		window.changeImg = false;

		$scope.createEmailTemplate = function() {
			$scope.isAddTemplateSpinnningWheelActive = true;

			const emailTemplate = angular.copy($scope.newEmailTemplate);

			const maxSize = 10; // 10Mb

			if (
				$scope.newAttachmentsData &&
				$scope.newAttachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isAddTemplateSpinnningWheelActive = false;
				return false;
			}

			if (!isEmailFieldsValid(emailTemplate)) {
				$scope.isAddTemplateSpinnningWheelActive = false;
				return;
			}

			if (emailTemplate) {
				emailTemplate.text = $rootScope.addMaiStyling(emailTemplate.text);
			}

			if (emailTemplate.id) {
				delete emailTemplate.id;
			}

			const { attachments } = $scope.newAttachmentsData;

			let uploadedAttachments, storedAttachments;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(attachment => !attachment.id);

				storedAttachments = attachments.filter(attachment => attachment.id);
			}

			emailTemplate.storedAttachments =
				storedAttachments && storedAttachments.length
					? storedAttachments
					: null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave(uploadedAttachments)
					.then(convertedFilesArr => {
						emailTemplate.base64Attachments = convertedFilesArr;
						saveEmailTemplate(emailTemplate);
					})
					.catch(error => console.log(error));
			} else {
				saveEmailTemplate(emailTemplate);
			}
		};

		function saveEmailTemplate(emailTemplate) {
			emailSettingsDataService
				.saveEmailTemplate(emailTemplate)
				.finally(() => ($scope.isAddTemplateSpinnningWheelActive = false))
				.subscribe(
					data => successCreateEmailTemplate(data),
					err => errorSaveEmailTemplate(err)
				);
		}

		function successCreateEmailTemplate(data) {
			messageService.showToaster(
				's_4',
				'emailTemplate',
				$scope.newEmailTemplate.name
			);
			$('#addNewTemplateModal').modal('hide');
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			delete $scope.newEmailTemplate;
		}

		function errorSaveEmailTemplate({ error }) {
			const { errorTitle, errorMessage } = error;

			if (errorMessage === 'Email template with same name is already exist') {
				messageService.showToaster('e_8', 'emailTemplate');
			} else {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			}
			$scope.isConfirmUpdateTemplateModalActive = false;
		}

		$scope.openEditModal = function(index) {
			const currentEmailTemplate = $scope.emailTemplates[index];
			const defaultEmailTemplate = currentEmailTemplate.defaultEmailTemplate;

			getEmailTemplate(currentEmailTemplate.id, result => {
				const data = angular.copy(result);

				data.defaultEmailTemplate = defaultEmailTemplate;
				if (data.storedAttachments.length) {
					$scope.editedAttachmentsData.attachments = fileUploadService.convertAttachmentsToShow(
						data.storedAttachments
					);
				} else {
					clearEditedAttachments();
				}

				if ($scope.$parent.editedEmailTemplate) {
					$scope.$parent.editedEmailTemplate = data;
				} else {
					$scope.editedEmailTemplate = data;
				}

				$('#editEmailTemplateModal')
					.modal('show')
					.on('shown.bs.modal', function() {
						$(this)
							.find('input')
							.first()
							.focus();

						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});
			});
		};

		function isEmailFieldsValid(email) {
			const { name, subject } = email;

			if (validationService.isStringEmpty(name)) {
				messageService.showToaster('e_9', 'emailTemplate', 'name');
				return false;
			}

			if (validationService.isStringEmpty(subject)) {
				messageService.showToaster('e_9', 'emailTemplate', 'subject');
				return false;
			}

			return true;
		}

		$scope.validateEditedTemplate = event => {
			$scope.isEditTemplateSpinnningWheelActive = true;

			const maxSize = 10; // 10Mb

			if (
				$scope.editedAttachmentsData &&
				$scope.editedAttachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isEditTemplateSpinnningWheelActive = false;
				return false;
			}

			if (!isEmailFieldsValid($scope.editedEmailTemplate)) {
				$scope.isEditTemplateSpinnningWheelActive = false;
				return false;
			}

			if ($scope.editedEmailTemplate) {
				$scope.editedEmailTemplate.text = $rootScope.addMaiStyling(
					$scope.editedEmailTemplate.text
				);
			}

			const { attachments } = $scope.editedAttachmentsData;

			let uploadedAttachments, storedAttachments;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(attachment => !attachment.id);

				storedAttachments = attachments.filter(attachment => attachment.id);
			}

			$scope.editedEmailTemplate.storedAttachments =
				storedAttachments && storedAttachments.length
					? storedAttachments
					: null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave(uploadedAttachments)
					.then(convertedFilesArr => {
						$scope.editedEmailTemplate.base64Attachments = convertedFilesArr;
						saveEditedEmailTemplate($scope.editedEmailTemplate, event);
					})
					.catch(error => console.log(error));
			} else {
				saveEditedEmailTemplate($scope.editedEmailTemplate);
			}
		};

		function saveEditedEmailTemplate(emailTemplate, event) {
			emailSettingsDataService
				.updateEmailTemplate(emailTemplate)
				.finally(() => ($scope.isEditTemplateSpinnningWheelActive = false))
				.subscribe(() => successValidation(event), err => errorValidation(err));
		}

		function successValidation(event) {
			emailSettingsDataService
				.confirmEditEmailTemplate($scope.editedEmailTemplate)
				.subscribe(
					() => successEditEmailTemplate(),
					err => errorSaveEmailTemplate(err)
				);
		}

		function errorValidation(result) {
			const { data, status } = result;

			if (status !== 422) {
				return messageService.showToaster('e_0', 'general');
			}

			const path = $location.path();
			const emailName = $scope.editedEmailTemplate.defaultEmailTemplate;

			if (data.errorMessage) {
				const isEmailNameRepeated =
					data.errorMessage ===
					'Email template with same name is already exist';
				if (isEmailNameRepeated) {
					return messageService.showToaster('e_8', 'emailTemplate');
				}
			}

			if (path.includes('settings')) {
				return showMessagesForEmailLinks(emailName);
			}
		}

		function showMessagesForEmailLinks(emailName) {
			let errorCode;
			switch (emailName) {
				case 'QUOTE_EMAIL_TEMPLATE':
					errorCode = 'e_1';
					break;
				case 'INVOICE_EMAIL_TEMPLATE':
					errorCode = 'e_0';
					break;
				case 'CONTRACT_EMAIL_TEMPLATE':
					errorCode = 'e_2';
					break;
				case 'QUESTIONNAIRE_EMAIL_TEMPLATE':
					errorCode = 'e_3';
					break;
				case 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE':
					errorCode = 'e_4';
					break;
				default:
					return messageService.showToaster('e_0', 'general');
			}
			return messageService.showToaster(errorCode, 'emailTemplate');
		}

		function successEditEmailTemplate() {
			messageService.showToaster(
				's_3',
				'emailTemplate',
				$scope.editedEmailTemplate.name
			);
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			$('#editEmailTemplateModal').modal('hide');
			$scope.isConfirmUpdateTemplateModalActive = false;
		}

		$scope.duplicateEmailTemplate = function(index) {
			getEmailTemplate($scope.emailTemplates[index].id, result => {
				$scope.newEmailTemplate = result;
				if (result.storedAttachments.length) {
					$scope.newAttachmentsData.attachments = fileUploadService.convertAttachmentsToShow(
						result.storedAttachments
					);
				} else {
					clearNewAttachments();
				}
				$scope.modal_title = 'Duplicate email template';
				$('#addNewTemplateModal')
					.modal('show')
					.on('shown.bs.modal', function() {
						$(this)
							.find('input')
							.first()
							.focus();

						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});
			});
		};

		$scope.openAddModal = function() {
			delete $scope.newEmailTemplate;
			clearNewAttachments();
			$scope.modal_title = 'Add a new email template';
			$('#addNewTemplateModal')
				.modal('show')
				.on('shown.bs.modal', function() {
					$(this)
						.find('input')
						.first()
						.focus();

					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};

		$scope.openDeleteWindow = function(index) {
			$scope.$parent.deleteableEmailTemplate = $scope.emailTemplates[index];
			$('#deleteEmailTemplateModal').modal('show');
		};

		$scope.deleteEmailTemplate = () => {
			$scope.isDeleteTemplateSpinnningWheelActive = true;

			emailSettingsDataService
				.deleteEmailTemplate($scope.deleteableEmailTemplate)
				.finally(() => ($scope.isDeleteTemplateSpinnningWheelActive = false))
				.subscribe(
					() => successDeleteEmailTemplate(),
					err => errorDeleteEmailTemplate(err.data)
				);
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Email Templates' }
		];

		function successDeleteEmailTemplate() {
			messageService.showToaster(
				's_0',
				'emailTemplate',
				$scope.deleteableEmailTemplate.name
			);
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			$('#deleteEmailTemplateModal').modal('hide');
		}

		function errorDeleteEmailTemplate(data) {
			const isEmailUsed =
				data.errorMessage === 'Email template is used in workflow(s)';
			isEmailUsed
				? messageService.showToaster('e_7', 'emailTemplate')
				: messageService.showToaster('e_0', 'general');
		}

		function getEmailTemplate(emailTemplateId, outObject) {
			templateRequestsService
				.getTemplates('template_without_signature', emailTemplateId)
				.subscribe(
					data => successGetEmailTemplate(data, outObject),
					err => messageService.showDefaultErrorMessage(err)
				);
		}

		function successGetEmailTemplate(data, outObject) {
			if (data) {
				outObject(data);
			} else {
				toastr.error('Failed to load email template');
			}
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate !== null &&
				typeof reverse !== 'undefined' &&
				reverse !== null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage !== null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber !== null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems !== 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				emailSettingsDataService
					.getEmailTemplatesOnPage($scope.pageRequest)
					.subscribe(
						data => successGetResultPage(data),
						() => console.error("can't get result page")
					);
			}
		}

		function successGetResultPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data.total;
			let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);
			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.emailTemplates = addWorkflowNamesToTemplate(data.results);
		}

		function addWorkflowNamesToTemplate(templates) {
			return templates.map(template => {
				const isTemplateUsedInWorkflows = template.usingWorkflows.length > 0;
				template.nameToShow = isTemplateUsedInWorkflows
					? template.name +
					  stringModifierService.getUsedWorkflowsString(
							template.usingWorkflows
					  )
					: template.name;
				return template;
			});
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = function() {
			return true;
		};

		function initReminder() {
			$http.get('/protected/rest/calendar_reminder/get').then(
				result => {
					if (result.data) {
						$scope.reminder = result.data;
					} else {
						messageService.showToaster('e_0', 'general');
					}
				},
				() => {
					messageService.showToaster('e_0', 'general');
				}
			);
		}

		$scope.saveReminder = function() {
			$timeout(() => {
				if ($scope.reminder.text == '' || $scope.reminder.text == null) {
					messageService.showToaster('e_2', 'generalValidation');
					return false;
				}
				$scope.reminder.text = $rootScope.addMaiStyling($scope.reminder.text);
				$scope.isSaveSpinnningWheelActive = true;
				$http({
					method: 'POST',
					url: '/protected/rest/calendar_reminder/save',
					data: $scope.reminder
				})
					.then(
						() => {
							messageService.showToaster('s_0', 'googleCalendar');
						},
						() => {
							messageService.showToaster('e_0', 'general');
							console.log($scope.reminder.text);
						}
					)
					.then(() => {
						$scope.isSaveSpinnningWheelActive = false;
					});
			}, 1000);
		};
	}

	angular
		.module('main')
		.controller('EmailTemplatesController', EmailTemplatesController);

	EmailTemplatesController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'messageService',
		'validationService',
		'stringModifierService',
		'fileUploadService',
		'emailSettingsDataService',
		'templateRequestsService',
		'$timeout',
		'$http',
		'utilsService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/emailTemplatesController.js